<template>
    <div>
   
      <div
        id="box"
        @mouseenter="mouseenterEvent()"
        @mouseleave="mouseleaveEvent(scrollTime)"
      >
        <ul id="listbox1">
          <li v-for="(item, index) in list" :key="index">{{ item }}</li>
        </ul>
        <ul id="listbox2">
    
        </ul>
      </div>
    </div>
</template>
   
  <script>
  export default {
    data() {
      return {
        list: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
        timer: null,
        scrollTime: 20,
      };
    },
    methods: {
/**
         * 获取签到日期
         */
        getSign(signDate) {
            let vm = this;
            // 接口未完成，模拟数据
            // const sign_days = [];
            signDate.forEach((item) => {
                this.arrDate.push(parseInt(item.sign_date.substr(8, 2)));
            });
            this.initData(null);
        },
        initData(cur) {
            let date;
            if (cur) {
                // 切换日期
                date = new Date(cur);
            } else {
                var now = new Date();
                var d = new Date(
                    this.formatDate(now.getFullYear(), now.getMonth() + 1, 1)
                );
                d.setDate(35); // 设置天数为35天
                date = new Date(
                    this.formatDate(d.getFullYear(), d.getMonth(), 1)
                );
            }
            this.currentDay = date.getDate(); // 今日日期 几号
            this.currentYear = date.getFullYear(); // 当前年份
            this.currentMonth = date.getMonth() + 1; // 当前月份

            this.currentWeek = date.getDay(); // 0,1...6 星期
            const str = this.formatDate(
                this.currentYear,
                this.currentMonth,
                this.currentDay
            ); // 2020-01-01
            this.days.length = 0; // 初始化日期
            // 如果今天是周日，放在第一行第7个位置，前面6个 这里默认显示一周，如果需要显示一个月，则第二个循环为 i<= 35- this.currentWeek
            for (var i = this.currentWeek; i > 0; i--) {
                const d = new Date(str);
                d.setDate(d.getDate() - i);
                var dayobject = {}; // 用一个对象包装Date对象 以便为以后预定功能添加属性
                dayobject.MonthDay = d;
                this.days.push(dayobject); // 将日期放入data 中的days数组 供页面渲染使用
            }
            // 其他周 // 设置天数为35天,周日设置在第一位，循环从36开始
            this.num = 0;
            for (var j = 0; j <= 36 - this.currentWeek; j++) {
                const d = new Date(str);
                d.setDate(d.getDate() + j);
                const dddd = d.getDate();
                if (dddd === 1) {
                    this.num++;
                }
                if (this.num === 2) {
                    return;
                }
                const dayobject = { MonthDay: d, isSign: this.isVerDate(dddd) };
                this.days.push(dayobject);
            }
        },
        /**
         * 判断该日期是否有签到
         * @param v
         * @returns {boolean}
         */
        isVerDate(v) {
            return this.arrDate.includes(v);
        },
        /**
         * 上一月
         * @param year
         * @param month
         */
        pickPre(year, month) {
            const d = new Date(this.formatDate(year, month, 1));
            d.setDate(0);
            this.initData(
                this.formatDate(d.getFullYear(), d.getMonth() + 1, 1)
            );
        },
        /**
         * 下一月
         * @param year
         * @param month
         */
        pickNext(year, month) {
            const d = new Date(this.formatDate(year, month, 1));
            d.setDate(35);
            this.initData(
                this.formatDate(d.getFullYear(), d.getMonth() + 1, 1)
            );
        },
        // 返回 类似 2020-01-01 格式的字符串
        formatDate(year, month, MonthDay) {
            month < 10 && (month = "0" + month);
            MonthDay < 10 && (MonthDay = "0" + MonthDay);
            const data = year + "-" + month + "-" + MonthDay;
            return data;
        },
        //获取当日毫秒数
        getTime() {
            let date = new Date();
            let y = date.getFullYear();
            let m = date.getMonth() + 1;
            let d = date.getDate();
            m = m <= 9 ? "0" + m : m;
            d = d <= 9 ? "0" + d : d;
            let str = y + "-" + m + "-" + d;
            let time = new Date(str).getTime();
            return time
        },
        //是否已签到
        changeSign(signDate) {
            let vm = this;
            let time = new Date(
                signDate[signDate.length - 1].sign_date.substr(0, 10)
            ).getTime();
            let timeNow = vm.getTime();
            if (time === timeNow) {
                vm.sign = true;
            }
        },
        /**
         * 点击签到
         * @param index
         */
        Sign() {
            let vm = this;
            const now = new Date();
            // vm.arrDate.push(now.getDate());
            vm.initData();
            vm.sign = true;
            const userinfo = getUserInfo();
            var obj = {
                userid: getUserId(),
                sign_id: vm.sign_id,
            };
            Axios.post("/gold/activate/signin",{
                params: obj,
            },{
                headers: {
                    "Content-Type": "application/json",
                },
            }).then((res) => {
                vm.$message({
                    message: "恭喜你,签到成功",
                    type: "success",
                });
                vm.MonthDay++;
            }).catch((err) => {
                vm.$message({
                    message: err.res.errorMsg,
                    type: "warning",
                });
            });
        },
        //连续签到
        continuitySign(signDate) {
            let vm = this;
            let arr = signDate;
            let MonthDay = 0;
            for (let i = 0; i < arr.length; i++) {
                let a = parseInt(arr[i].sign_date.substr(8, 2));
                let b = null;
                if (arr[i + 1]) {
                    b = parseInt(arr[i + 1].sign_date.substr(8, 2));
                } else {
                    b = parseInt(arr[i].sign_date.substr(8, 2));
                    b++;
                }
                a++;
                if (a == b) {
                    MonthDay += 1;
                }else{
                    MonthDay = 0
                }
            }
            // if (vm.sign == true) {
            //     MonthDay += 1;
            // }
            vm.MonthDay = MonthDay;
        },
        // 记录签到天数
        record() {
            let vm = this;
            const userinfo = getUserInfo();
            var obj = {
                userid: getUserId(),
                sign_id: this.sign_id,
            };
            Axios.post("/gold/activate/getsigndetaillist",{
                params: obj,
            },{
                headers: {
                    "Content-Type": "application/json",
                },
            }).then((res) => {
                let signDate = res.data;
                signDate.forEach
                for(var i=0;i<res.data.length;i++)
                {
                    var newtime=res.data[i].sign_date
                    var newmoth= newtime.split('-');
                    var newmothy=  newmoth[1]+'-'+newmoth[2].substr(0,2);
                    vm.tableTime.push(newmothy)
                }
                vm.getSign(signDate);
                vm.changeSign(signDate);
                vm.continuitySign(signDate);
            }).catch((err) => {

            });
        },
        // 判断活动类型
        activityType() {
            let vm = this;
            const userinfo = getUserInfo();
            var obj = {
                userid: getUserId(),
            };
            Axios.post("/gold/activate/getnowsign",{
                params: obj,
            },{
                headers: {
                    "Content-Type": "application/json",
                },
            }).then((res) => {
                this.sign_id = res.data.sign_id;
            }).catch((err) => {
                
            });
        },













      scroll(t) {
        var ul1 = document.getElementById("listbox1");
   
        var ul2 = document.getElementById("listbox2");
   
        var ulbox = document.getElementById("box");
   
        ul2.innerHTML = ul1.innerHTML;
   
        ulbox.scrollTop = 0; // 开始无滚动时设为0
   
        this.timer = setInterval(this.rollStart, t);
      },
      // 开启滚动
      rollStart() {
        // 上面声明的DOM对象为局部对象需要再次声明
        // 无缝轮播需要两个相同内容的盒子
        var ul1 = document.getElementById("listbox1");
   
        // var ul2 = document.getElementById("listbox2");
   
        var ulbox = document.getElementById("box");
   
        // 正常滚动不断给scrollTop的值+1,当滚动高度大于列表内容高度时恢复为0
   
        if (ulbox.scrollTop >= ul1.scrollHeight) {
          ulbox.scrollTop = 0;
        } else {
          ulbox.scrollTop++;
        }
      },
      // 鼠标移入关闭定时器
      mouseenterEvent() {
        if (this.timer) {
          clearInterval(this.timer);
          this.timer = null;
        }
        // // 只显示一个盒子的内容
        // document.getElementById("listbox2").style.display = "none";
      },
      // 鼠标移出重新调用定时器
      mouseleaveEvent(t) {
        console.log(1);
        if (!this.timer) {
          this.timer = setInterval(this.rollStart, t);
        }
        //  document.getElementById("listbox2").style.display = "block";
      },
    },
    mounted() {
      //开启滚动
      this.scroll(this.scrollTime);
    },
    destroyed() {
      // 页面销毁清除定时器
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
  };
  </script>
   
  <style lang="scss" scoped>
  #box {
    width: 500px;
    height: 200px;
    border: 1px solid #000;
    //溢出隐藏
    overflow: hidden;
    &:hover {
      // 实现Y轴可滚动
      overflow-y: scroll;
    }
    &::-webkit-scrollbar {
      width: 0px;
    }
  }
  #listbox1 {
    width: 500px;
    height: 400px;
    // border: 1px solid red;
    box-sizing: border-box;
   
    li {
      height: 40px;
      border: 1px solid blue;
      box-sizing: border-box;
    }
  }
  #listbox2 {
    width: 500px;
    height: 400px;
    border: 1px solid red;
    box-sizing: border-box;
   
    li {
      height: 40px;
      border: 1px solid blue;
      box-sizing: border-box;
    }
  }
  </style>


// WEBPACK FOOTER //
// src/views/ChildPages/queryAddress.vue